import React from 'react'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import SplitButton from 'components_new/molecules/SplitButton'

import { Context } from 'types/GlobalUserEvents'
import { addRef } from 'utils/queryHandler'
import { useTranslation } from 'language/translator'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useSnackbarActions } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

interface ActionsProps {
  showActions: boolean
  isPublic: boolean
  onClose: () => void
  publicLink: string
  setTab: (value: 'email' | 'default') => void
  tab: 'email' | 'default'
}

const Actions = (props: ActionsProps) => {
  const { showActions, isPublic, publicLink, setTab, tab } = props

  const { isAdmin } = useAccountSettings()

  const { t } = useTranslation()
  const { toggleSnackbarOpen } = useSnackbarActions()

  const copyCurrentUrl = () => {
    const currentUrl = addRef(window.location.href, Context.SHARE_LINK)

    navigator.clipboard
      .writeText(currentUrl)
      .then(() => toggleSnackbarOpen(SnackbarMessage.CopiedToClipboard))
      .catch((err) => console.error('Failed to copy current URL:', err))
  }

  const copyPublicLink = () => {
    navigator.clipboard
      .writeText(publicLink)
      .then(() => toggleSnackbarOpen(SnackbarMessage.CopiedToClipboard))
      .catch((err) => console.error('Failed to copy public link:', err))
  }

  return (
    <>
      {tab === 'default' ? (
        <>
          {showActions ? (
            <>
              <SplitButton
                onClick={copyCurrentUrl}
                options={[
                  {
                    disabled: !isPublic,
                    iconName: 'PublicOutlined',
                    infoTip: t('dashboards', 'tab_not_public'),
                    title: t('dashboards', 'copy_tab_public_link'),
                    onClick: copyPublicLink
                  }
                ]}
                startIcon={<Icon name="Link" />}
                title={t('global', 'copy_link')}
              />
              {/* Only admins can invite new users */}
              {isAdmin ? (
                <Button
                  startIcon={<Icon name="MailOutlined" />}
                  variant="outlined"
                  onClick={() => setTab('email')}
                >
                  {t('global', 'invite')}
                </Button>
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  )
}

export default Actions
